// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
// 	Button,
// 	Container,
// 	Typography,
// 	Box,
// 	Paper,
// 	Table,
// 	TableHead,
// 	TableRow,
// 	TableCell,
// 	TableBody,
// 	IconButton,
// 	Menu,
// 	MenuItem,
// 	ListItemIcon,
// 	ListItemText,
// 	TablePagination,
// 	Checkbox,
// 	CircularProgress,
// 	Tooltip,
// 	Select,
// 	Chip,
// 	useMediaQuery,
// 	useTheme,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	TextField,
// 	InputAdornment,
// } from '@mui/material';
// import {
// 	AddCircle as AddCircleIcon,
// 	Visibility,
// 	Edit,
// 	MoreVert,
// 	ViewColumn as ViewColumnIcon,
// 	Close,
// 	Search,
// } from '@mui/icons-material';
// // import QuotationModal from './quotationFrom';
// import { Quotation, QuotationStatus } from '../../../types/quotation';
// import Toast from '../Toast/page';
// // import { getAllEvent } from '../../../services/api/Event';
// import {
// 	// createQuotation,
// 	getAllQuotation,
// 	HandlePDFCreate,
// 	// updateQuotation,
// 	updateQuotationStatus,
// } from '../../../services/api/quotation';
// const columnOptions = [
// 	{ id: 'quotationId', label: 'Quotation ID', default: false },
// 	{ id: 'name', label: 'Customer Name', default: true },
// 	// { id: 'eventType.eventType', label: 'Event Type', default: true },
// 	{ id: 'email', label: 'Email', default: false },
// 	{ id: 'mobile', label: 'Phone', default: true },
// 	{ id: 'eventLocation', label: 'Location', default: false },
// 	{ id: 'eventDate', label: 'Event Date', default: true },
// 	{ id: 'finalAmount', label: 'Amount', default: true },
// 	{ id: 'status', label: 'Status', default: true },
// ];
// const statusOptions: QuotationStatus[] = [
// 	'Rejected',
// 	'Quotation Sent',
// 	'Confirmed',
// 	'Pending',
// 	'New',
// ];
// const QuotationPage = () => {
// 	const theme = useTheme();
// 	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// 	const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
// 	// const [quotationloader, setQuotationloader] = useState(false);
// 	// const [editingQuotation, setEditingQuotation] = useState<Quotation | null>(null);
// 	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
// 	const [currentQuotationId, setCurrentQuotationId] = useState<string | null>(null);
// 	const [loading, setLoading] = useState(true);
// 	const [alertMessage, setAlertMessage] = useState<string | null>(null);
// 	// const [selectedQuotation, setSelectedQuotation] = useState<any | null>(null);
// 	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
// 		'success'
// 	);
// 	const [page, setPage] = useState(0);
// 	const [rowsPerPage, setRowsPerPage] = useState(5);
// 	const [columns, setColumns] = useState(
// 		columnOptions.reduce(
// 			(acc, col) => ({ ...acc, [col.id]: isMobile ? false : col.default }),
// 			{} as Record<string, boolean>
// 		)
// 	);
// 	const [columnsMenuAnchor, setColumnsMenuAnchor] = useState<null | HTMLElement>(null);
// 	// const [eventTypes, setEventTypes] = useState<string[]>([]);
// 	const [quotations, setQuotations] = useState<Quotation[]>([]);
// 	const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
// 	const [selectedPdfUrl, setSelectedPdfUrl] = useState('');
// 	const [searchTerm, setSearchTerm] = useState('');
// 	const navigate = useNavigate();

// 	useEffect(() => {
// 		if (isMobile) {
// 			setColumns({
// 				quotationId: false,
// 				name: true,
// 				email: false,
// 				mobile: true,
// 				eventLocation: false,
// 				eventDate: true,
// 				finalAmount: true,
// 				status: true,
// 			});
// 		} else if (isTablet) {
// 			setColumns({
// 				quotationId: true,
// 				name: true,
// 				email: false,
// 				mobile: true,
// 				eventLocation: false,
// 				eventDate: true,
// 				finalAmount: true,
// 				status: true,
// 			});
// 		} else {
// 			// Desktop/laptop - use defaults
// 			setColumns(
// 				columnOptions.reduce(
// 					(acc, col) => ({ ...acc, [col.id]: col.default }),
// 					{} as Record<string, boolean>
// 				)
// 			);
// 		}
// 	}, [isMobile, isTablet]);
// 	const mapApiDataToQuotation = (apiData: any): Omit<Quotation, 'quotationId'> => ({
// 		_id: apiData._id,
// 		name: apiData.name,
// 		email: apiData.email,
// 		mobile: apiData.mobile,
// 		eventType: apiData.eventType || '',
// 		functionDate: apiData.functionDate,
// 		location: apiData.location,
// 		status: apiData.status === 'New' ? 'New' : (apiData.status as QuotationStatus) || 'draft',
// 		menuTypes:
// 			apiData.menuTypes?.map((menu: any) => ({
// 				type: menu.menuType,
// 				items: menu.menuItems?.Items || [],
// 				perPerson: menu.perPerson,
// 				totalPersons: menu.numberOfPersons,
// 				discount: menu.discount,
// 				datetime: menu.datetime,
// 			})) || [],
// 		description: apiData.description,
// 		complementary:
// 			apiData.complementary
// 				?.filter((item: any) => item.item || item.name)
// 				?.map((items: any) => ({
// 					item: items.item || items.name || '',
// 					quantity: Number(items.quantity) || 0,
// 					price: Number(items.price) || 0,
// 				})) || [],
// 		extraItems:
// 			apiData.extratEvents?.map((item: any) => ({
// 				item: item.item,
// 				price: item.price,
// 			})) || [],
// 		menuTotal:
// 			apiData.menuTypes?.reduce((sum: number, menu: any) => sum + (menu.price || 0), 0) || 0,
// 		extraItemsTotal:
// 			apiData.extratEvents?.reduce((sum: number, item: any) => sum + (item.price || 0), 0) ||
// 			0,
// 		subtotal: apiData.subTotalPrice || 0,
// 		discount: apiData.discount || 0,
// 		gstPercentage: apiData.gstPercentage || 0,
// 		totalPrice: apiData.totalPrice || 0,
// 		isDefaultMenu: apiData.isDefaultMenu || false,
// 		finalAmount: apiData.totalPrice || 0,
// 		defaultMenuId: apiData.defaultMenuId || null,
// 		createdAt: apiData.createdAt,
// 		updatedAt: apiData.updatedAt,
// 		quotationPdf: apiData.quotationPdf,
// 		masterquotationPdf: apiData.masterquotationPdf,
// 	});

// 	const loadQuotations = useCallback(async () => {
// 		setLoading(true);
// 		try {
// 			const response = await getAllQuotation();
// 			const mappedQuotations = response.data.quotations.map(mapApiDataToQuotation);
// 			setQuotations(mappedQuotations);
// 			setAlertMessage('Data loaded successfully');
// 			setAlertSeverity('success');
// 		} catch (error) {
// 			setAlertMessage('Failed to load data');
// 			setAlertSeverity('error');
// 			console.error('Error loading data:', error);
// 		} finally {
// 			setLoading(false);
// 		}
// 	}, []);

// 	useEffect(() => {
// 		loadQuotations();
// 		// loadEventTypes();
// 	}, [loadQuotations]);

// 	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
// 		setAnchorEl(event.currentTarget);
// 		setCurrentQuotationId(id);
// 	};

// 	const handleMenuClose = () => {
// 		setAnchorEl(null);
// 		setCurrentQuotationId(null);
// 	};
// 	const handleStatusChange = async (id: string, newStatus: QuotationStatus) => {
// 		try {
// 			const response = await updateQuotationStatus({ status: newStatus }, id);
// 			const data = response;
// 			if (data) {
// 				setQuotations(
// 					quotations.map((q) => (q._id === id ? { ...q, status: newStatus } : q))
// 				);
// 				setAlertMessage('Status updated successfully');
// 				setAlertSeverity('success');
// 			}
// 		} catch (error) {
// 			setAlertMessage('Failed to update status');
// 			setAlertSeverity('error');
// 			console.error('Error updating status:', error);
// 		}
// 	};
// 	const handleDownloadQuotation = async (id: string, type: 'master' | 'client') => {
// 		const quotation = quotations.find((q) => q._id === id);
// 		if (!quotation) return;

// 		try {
// 			setLoading(true);
// 			const response = await HandlePDFCreate(type, id);
// 			const apiurl = response.data.pdfUrl;
// 			const pdfUrl =
// 				type === 'master'
// 					? quotation?.masterquotationPdf || apiurl
// 					: quotation.quotationPdf || apiurl;

// 			setSelectedPdfUrl(pdfUrl);
// 			setPdfDialogOpen(true);

// 			setAlertMessage(
// 				`${type === 'master' ? 'Master' : 'Client'} PDF generated successfully`
// 			);
// 			setAlertSeverity('success');
// 		} catch (error) {
// 			setAlertMessage('Failed to generate PDF');
// 			setAlertSeverity('error');
// 			console.error('Error generating PDF:', error);
// 		} finally {
// 			setLoading(false);
// 			handleMenuClose();
// 		}
// 	};

// 	const handleChangePage = (event: unknown, newPage: number) => {
// 		setPage(newPage);
// 	};

// 	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
// 		setRowsPerPage(parseInt(event.target.value, 10));
// 		setPage(0);
// 	};

// 	const handleColumnsMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
// 		setColumnsMenuAnchor(event.currentTarget);
// 	};

// 	const handleColumnsMenuClose = () => {
// 		setColumnsMenuAnchor(null);
// 	};

// 	const toggleColumnVisibility = (columnId: string) => {
// 		setColumns((prev) => ({
// 			...prev,
// 			[columnId]: !prev[columnId],
// 		}));
// 	};

// 	// Filter quotations based on search term
// 	const filteredQuotations = quotations.filter((quotation) => {
// 		const searchLower = searchTerm.toLowerCase();
// 		return (
// 			quotation.name?.toLowerCase().startsWith(searchLower) ||
// 			quotation.email?.toLowerCase().startsWith(searchLower) ||
// 			quotation.mobile?.toLowerCase().startsWith(searchLower) ||
// 			quotation.location?.toLowerCase().startsWith(searchLower)
// 		);
// 	});

// 	const visibleColumns = columnOptions.filter((col) => columns[col.id]);

// 	return (
// 		<Container maxWidth="xl" sx={{ py: 4, px: isMobile ? 1 : 2 }}>
// 			<Box
// 				sx={{
// 					display: 'flex',
// 					flexDirection: isMobile ? 'column' : 'row',
// 					justifyContent: 'space-between',
// 					alignItems: isMobile ? 'flex-start' : 'center',
// 					mb: 4,
// 					gap: isMobile ? 2 : 0,
// 				}}
// 			>
// 				<Typography
// 					variant={isMobile ? 'h5' : 'h4'}
// 					component="h1"
// 					sx={{ fontWeight: 'bold' }}
// 				>
// 					{' '}
// 					<TextField
// 						variant="outlined"
// 						size="small"
// 						placeholder="Search by name, email, phone or location"
// 						value={searchTerm}
// 						onChange={(e) => setSearchTerm(e.target.value)}
// 						InputProps={{
// 							startAdornment: (
// 								<InputAdornment position="start">
// 									<Search />
// 								</InputAdornment>
// 							),
// 						}}
// 						sx={{
// 							width: isMobile ? '100%' : 300,
// 							mr: 1,
// 						}}
// 					/>
// 				</Typography>
// 				<Box sx={{ display: 'flex', gap: 1, width: isMobile ? '100%' : 'auto' }}>
// 					<Tooltip title="Select columns">
// 						<IconButton
// 							onClick={handleColumnsMenuOpen}
// 							size={isMobile ? 'small' : 'medium'}
// 						>
// 							<ViewColumnIcon fontSize={isMobile ? 'small' : 'medium'} />
// 						</IconButton>
// 					</Tooltip>
// 					<Button
// 						variant="contained"
// 						startIcon={<AddCircleIcon fontSize={isMobile ? 'small' : 'medium'} />}
// 						onClick={() => navigate('/quotation/create')}
// 						size={isMobile ? 'small' : 'medium'}
// 					>
// 						{isMobile ? 'Add' : 'Add Quotation'}
// 					</Button>
// 				</Box>
// 			</Box>

// 			{loading ? (
// 				<Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
// 					<CircularProgress />
// 				</Box>
// 			) : filteredQuotations.length > 0 ? (
// 				<Paper elevation={2} sx={{ p: isMobile ? 1 : 2, overflowX: 'auto' }}>
// 					<Box sx={{ minWidth: isMobile ? '600px' : '100%' }}>
// 						<Table size={isMobile ? 'small' : 'medium'}>
// 							<TableHead>
// 								<TableRow>
// 									{visibleColumns.map((column) => (
// 										<TableCell key={column.id} sx={{ fontWeight: 'bold' }}>
// 											{column.label}
// 										</TableCell>
// 									))}
// 									<TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
// 								</TableRow>
// 							</TableHead>
// 							<TableBody>
// 								{filteredQuotations
// 									.slice()
// 									.reverse()
// 									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
// 									.map((quotation) => (
// 										<TableRow key={quotation._id} hover>
// 											{visibleColumns.map((column) => {
// 												switch (column.id) {
// 													case 'status':
// 														return (
// 															<TableCell key={column.id}>
// 																<Select
// 																	size="small"
// 																	value={quotation.status}
// 																	onChange={(e) =>
// 																		handleStatusChange(
// 																			quotation._id,
// 																			e.target
// 																				.value as QuotationStatus
// 																		)
// 																	}
// 																	sx={{
// 																		border: 'none',
// 																		'& .MuiOutlinedInput-notchedOutline':
// 																		{
// 																			border: 'none',
// 																		},
// 																		'&:hover .MuiOutlinedInput-notchedOutline':
// 																		{
// 																			border: 'none',
// 																		},
// 																		'&.Mui-focused .MuiOutlinedInput-notchedOutline':
// 																		{
// 																			border: 'none',
// 																		},
// 																	}}
// 																>
// 																	{statusOptions.map((status) => (
// 																		<MenuItem
// 																			key={status}
// 																			value={status}
// 																			sx={{
// 																				textTransform:
// 																					'capitalize',
// 																			}}
// 																		>
// 																			<Chip
// 																				label={status}
// 																				color={status === 'Quotation Sent' ? 'success' : status === 'Rejected' ? 'warning' : status === 'Confirmed' ? 'success' : status === 'Pending' ? 'info' : 'default'}
// 																				size="small"
// 																			/>
// 																		</MenuItem>
// 																	))}
// 																</Select>
// 															</TableCell>
// 														);
// 													case 'finalAmount':
// 														return (
// 															<TableCell key={column.id}>
// 																₹{quotation.finalAmount.toFixed(2)}
// 															</TableCell>
// 														);
// 													case 'eventDate':
// 														return (
// 															<TableCell key={column.id}>
// 																{new Date(
// 																	quotation.functionDate
// 																).toLocaleDateString()}
// 															</TableCell>
// 														);
// 													case 'updatedAt':
// 														return (
// 															<TableCell key={column.id}>
// 																{new Date(
// 																	quotation.updatedAt
// 																).toLocaleString()}
// 															</TableCell>
// 														);
// 													default:
// 														return (
// 															<TableCell key={column.id}>
// 																{String(
// 																	quotation[
// 																	column.id as keyof Quotation
// 																	]
// 																)}
// 															</TableCell>
// 														);
// 												}
// 											})}
// 											<TableCell>
// 												<IconButton
// 													size={isMobile ? 'small' : 'medium'}
// 													onClick={(e) =>
// 														handleMenuOpen(e, quotation._id)
// 													}
// 												>
// 													<MoreVert
// 														fontSize={isMobile ? 'small' : 'medium'}
// 													/>
// 												</IconButton>

// 												<Menu
// 													anchorEl={anchorEl}
// 													open={
// 														Boolean(anchorEl) &&
// 														currentQuotationId === quotation._id
// 													}
// 													onClose={handleMenuClose}
// 													anchorOrigin={{
// 														vertical: 'bottom',
// 														horizontal: 'right',
// 													}}
// 													transformOrigin={{
// 														vertical: 'top',
// 														horizontal: 'right',
// 													}}
// 												>
// 													<MenuItem
// 														onClick={() =>
// 															(window.location.href = `/quotation/${quotation._id}`)
// 														}
// 													>
// 														<ListItemIcon>
// 															<Visibility fontSize="small" />
// 														</ListItemIcon>
// 														<ListItemText>View Details</ListItemText>
// 													</MenuItem>
// 													<MenuItem
// 														onClick={() =>
// 															navigate(
// 																`/quotation/edit/${quotation._id}`
// 															)
// 														}
// 													>
// 														<ListItemIcon>
// 															<Edit fontSize="small" />
// 														</ListItemIcon>
// 														<ListItemText>Edit</ListItemText>
// 													</MenuItem>

// 													<MenuItem
// 														onClick={
// 															quotation.masterquotationPdf
// 																? () =>
// 																	window.open(
// 																		quotation.quotationPdf,
// 																		"_blank'"
// 																	)
// 																: () =>
// 																	handleDownloadQuotation(
// 																		quotation._id,
// 																		'master'
// 																	)}
// 													>
// 														<ListItemIcon>
// 															<Visibility fontSize="small" />
// 														</ListItemIcon>
// 														<ListItemText>View Master PDF</ListItemText>
// 													</MenuItem>
// 													<MenuItem
// 														onClick={() =>
// 															window.open(
// 																quotation.quotationPdf,
// 																"_blank'"
// 															)
// 														}
// 													>
// 														<ListItemIcon>
// 															<Visibility fontSize="small" />
// 														</ListItemIcon>
// 														<ListItemText>View Client PDF</ListItemText>
// 													</MenuItem>
// 												</Menu>
// 											</TableCell>
// 										</TableRow>
// 									))}
// 							</TableBody>
// 						</Table>
// 					</Box>
// 					<TablePagination
// 						rowsPerPageOptions={[5, 10, 25]}
// 						component="div"
// 						count={filteredQuotations.length}
// 						rowsPerPage={rowsPerPage}
// 						page={page}
// 						onPageChange={handleChangePage}
// 						onRowsPerPageChange={handleChangeRowsPerPage}
// 						labelRowsPerPage={isMobile ? 'Rows:' : 'Rows per page:'}
// 						sx={{
// 							'& .MuiTablePagination-toolbar': {
// 								flexWrap: isMobile ? 'wrap' : 'nowrap',
// 							},
// 						}}
// 					/>
// 				</Paper>
// 			) : searchTerm ? (
// 				<Box
// 					sx={{
// 						textAlign: 'center',
// 						py: 8,
// 						backgroundColor: 'grey.50',
// 						borderRadius: 1,
// 						border: '1px dashed',
// 						borderColor: 'divider',
// 					}}
// 				>
// 					<Typography variant="h5" component="h3" fontWeight="medium" mb={1}>
// 						No matching quotations found
// 					</Typography>
// 					<Typography color="text.secondary" mb={3}>
// 						Try adjusting your search criteria
// 					</Typography>
// 					<Button
// 						variant="outlined"
// 						onClick={() => setSearchTerm('')}
// 						size={isMobile ? 'small' : 'medium'}
// 					>
// 						Clear search
// 					</Button>
// 				</Box>
// 			) : (
// 				<Box
// 					sx={{
// 						textAlign: 'center',
// 						py: 8,
// 						backgroundColor: 'grey.50',
// 						borderRadius: 1,
// 						border: '1px dashed',
// 						borderColor: 'divider',
// 					}}
// 				>
// 					<Typography variant="h5" component="h3" fontWeight="medium" mb={1}>
// 						No quotations yet
// 					</Typography>
// 					<Typography color="text.secondary" mb={3}>
// 						Create your first quotation to get started
// 					</Typography>
// 					<Button
// 						variant="contained"
// 						startIcon={<AddCircleIcon />}
// 						onClick={() => navigate('/quotation/create')}
// 						size={isMobile ? 'small' : 'medium'}
// 					>
// 						Create New Quotation
// 					</Button>
// 				</Box>
// 			)}

// 			<Menu
// 				anchorEl={columnsMenuAnchor}
// 				open={Boolean(columnsMenuAnchor)}
// 				onClose={handleColumnsMenuClose}
// 				PaperProps={{
// 					style: {
// 						maxHeight: 300,
// 						width: 200,
// 					},
// 				}}
// 			>
// 				<Typography variant="subtitle2" sx={{ px: 2, pt: 1, fontWeight: 'bold' }}>
// 					Visible Columns
// 				</Typography>
// 				{columnOptions.map((column) => (
// 					<MenuItem
// 						key={column.id}
// 						onClick={() => toggleColumnVisibility(column.id)}
// 						dense
// 					>
// 						<Checkbox checked={columns[column.id]} size="small" />
// 						<ListItemText primary={column.label} />
// 					</MenuItem>
// 				))}
// 			</Menu>

// 			<Dialog
// 				open={pdfDialogOpen}
// 				onClose={() => setPdfDialogOpen(false)}
// 				fullScreen={isMobile}
// 				maxWidth="lg"
// 				fullWidth
// 			>
// 				<DialogTitle>
// 					<Box display="flex" justifyContent="space-between" alignItems="center">
// 						PDF Preview
// 						<IconButton onClick={() => setPdfDialogOpen(false)}>
// 							<Close />
// 						</IconButton>
// 					</Box>
// 				</DialogTitle>
// 				<DialogContent sx={{ height: '80vh', p: 0 }}>
// 					{selectedPdfUrl && (
// 						<iframe
// 							src={selectedPdfUrl}
// 							width="100%"
// 							height="100%"
// 							style={{ border: 'none' }}
// 							title="PDF Preview"
// 						/>
// 					)}
// 				</DialogContent>
// 				<DialogActions>
// 					<Button
// 						onClick={() => {
// 							window.open(selectedPdfUrl, '_blank');
// 							setPdfDialogOpen(false);
// 						}}
// 						variant="contained"
// 						color="primary"
// 					>
// 						Open in New Tab
// 					</Button>
// 					<Button onClick={() => setPdfDialogOpen(false)} variant="outlined">
// 						Close
// 					</Button>
// 				</DialogActions>
// 			</Dialog>

// 			<Toast
// 				alertSeverity={alertSeverity}
// 				alertMessage={alertMessage}
// 				setAlertMessage={setAlertMessage}
// 			/>
// 		</Container>
// 	);
// };

// export default QuotationPage;
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
// =====================================================================================================================================
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	Button,
	Container,
	Typography,
	Box,
	Paper,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	IconButton,
	Menu,
	MenuItem,
	ListItemIcon,
	ListItemText,
	TablePagination,
	Checkbox,
	CircularProgress,
	Tooltip,
	Select,
	Chip,
	useMediaQuery,
	useTheme,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	InputAdornment,
} from '@mui/material';
import {
	AddCircle as AddCircleIcon,
	Visibility,
	Edit,
	MoreVert,
	ViewColumn as ViewColumnIcon,
	Close,
	Search,
} from '@mui/icons-material';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { GridDeleteForeverIcon, GridDeleteIcon } from '@mui/x-data-grid';
// import QuotationModal from './quotationFrom';
import { Quotation, QuotationStatus } from '../../../types/quotation';
import Toast from '../Toast/page';
// import { getAllEvent } from '../../../services/api/Event';
import {
	deleteQuotation,
	// createQuotation,
	getAllQuotation,
	HandlePDFCreate,
	SendQuotation,
	// updateQuotation,
	updateQuotationStatus,
} from '../../../services/api/quotation';

const columnOptions = [
	// { id: 'quotationId', label: 'Quotation ID', default: false },
	{ id: 'name', label: 'Customer Name', default: true },
	{ id: 'location', label: 'Location', default: true },
	{ id: 'eventType.eventType', label: 'Event Type', default: true }, // Added eventType
	{ id: 'email', label: 'Email', default: false },
	{ id: 'mobile', label: 'Phone', default: true },
	// { id: 'eventLocation', label: 'Location', default: false },
	{ id: 'eventDate', label: 'Event Date', default: true },
	{ id: 'finalAmount', label: 'Amount', default: true },
	{ id: 'status', label: 'Status', default: true },
];

const statusOptions: QuotationStatus[] = [
	'Rejected',
	'Quotation Sent',
	'Confirmed',
	'Pending',
	'New',
	'Quotation Created',
	'Quotation Updated',
];

const QuotationPage = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [currentQuotationId, setCurrentQuotationId] = useState<string | null>(null);
	const [loading, setLoading] = useState(true);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
		'success'
	);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [columns, setColumns] = useState(
		columnOptions.reduce(
			(acc, col) => ({ ...acc, [col.id]: isMobile ? false : col.default }),
			{} as Record<string, boolean>
		)
	);
	const [columnsMenuAnchor, setColumnsMenuAnchor] = useState<null | HTMLElement>(null);
	const [quotations, setQuotations] = useState<Quotation[]>([]);
	const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
	const [selectedPdfUrl, setSelectedPdfUrl] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
	const navigate = useNavigate();
	const [deleting, setDeleting] = useState(false);
	const [deleteId, setDeletedID] = useState(null);
	const [sendloaderquotation, setSendloaderQuotation] = useState(false);

	const handleDeleteClick = (id: any) => {
		console.log(id, 'id>>>>>>>>>>');

		setDeletedID(id);
		// handleDeleteQuotation(id);
		setDeleteDialogOpen(true);
	};

	const handleCloseDeleteDialog = () => {
		setDeleteDialogOpen(false);
		// setMenuToDelete(null);
	};
	useEffect(() => {
		if (isMobile) {
			setColumns({
				quotationId: false,
				name: true,
				location: true,
				email: false,
				mobile: true,
				eventLocation: false,
				eventDate: true,
				finalAmount: true,
				status: true,
				'eventType.eventType': true, // Added eventType
			});
		} else if (isTablet) {
			setColumns({
				quotationId: true,
				name: true,
				location: true,
				email: false,
				mobile: true,
				eventLocation: false,
				eventDate: true,
				finalAmount: true,
				status: true,
				'eventType.eventType': true, // Added eventType
			});
		} else {
			// Desktop/laptop - use defaults
			setColumns(
				columnOptions.reduce(
					(acc, col) => ({ ...acc, [col.id]: col.default }),
					{} as Record<string, boolean>
				)
			);
		}
	}, [isMobile, isTablet]);

	const mapApiDataToQuotation = (apiData: any): Omit<Quotation, 'quotationId'> => ({
		_id: apiData._id,
		name: apiData.name,
		email: apiData.email,
		mobile: apiData.mobile,
		eventType: apiData.eventType || '', // Ensure this line is correct
		functionDate: apiData.functionDate,
		location: apiData.location,
		status: apiData.status === 'New' ? 'New' : (apiData.status as QuotationStatus) || 'draft',
		advanceAmounts: apiData.advanceAmounts,
		menuTypes:
			apiData.menuTypes?.map((menu: any) => ({
				type: menu.menuType,
				items: menu.menuItems?.Items || [],
				perPerson: menu.perPerson,
				totalPersons: menu.numberOfPersons,
				discount: menu.discount,
				datetime: menu.datetime,
			})) || [],
		description: apiData.description,
		complementary:
			apiData.complementary
				?.filter((item: any) => item.item || item.name)
				?.map((items: any) => ({
					item: items.item || items.name || '',
					quantity: Number(items.quantity) || 0,
					price: Number(items.price) || 0,
				})) || [],
		extratEvents:
			apiData.extratEvents?.map((item: any) => ({
				item: item.item,
				price: item.price,
			})) || [],
		menuTotal:
			apiData.menuTypes?.reduce((sum: number, menu: any) => sum + (menu.price || 0), 0) || 0,
		extraItemsTotal:
			apiData.extratEvents?.reduce((sum: number, item: any) => sum + (item.price || 0), 0) ||
			0,
		subTotalPrice: apiData.subTotalPrice || 0,
		discount: apiData.discount || 0,
		gstPercentage: apiData.gstPercentage || 0,
		totalPrice: apiData.totalPrice || 0,
		isDefaultMenu: apiData.isDefaultMenu || false,
		finalAmount: apiData.totalPrice || 0,
		defaultMenuId: apiData.defaultMenuId || null,
		createdAt: apiData.createdAt,
		updatedAt: apiData.updatedAt,
		quotationPdf: apiData.quotationPdf,
		masterquotationPdf: apiData.masterquotationPdf,
		ifMasterquotationPdfGenrated: apiData.ifMasterquotationPdfGenrated,
	});

	const loadQuotations = useCallback(async () => {
		setLoading(true);
		try {
			const response = await getAllQuotation();
			const mappedQuotations = response.data.quotations.map(mapApiDataToQuotation);
			setQuotations(mappedQuotations);
			// setAlertMessage('Data loaded successfully');
			// setAlertSeverity('success');
		} catch (error) {
			setAlertMessage('Failed to load data');
			setAlertSeverity('error');
			console.error('Error loading data:', error);
		} finally {
			setLoading(false);
		}
	}, []);
	const handleDeleteQuotation = async () => {
		if (deleteId) {
			console.log(deleteId, 'ddadadaadadad');

			try {
				setDeleting(true);
				const response = await deleteQuotation(deleteId);
				if (response.success) {
					setQuotations(quotations.filter((q) => q._id !== deleteId));
					// handleMenuClose();
					handleCloseDeleteDialog();
					setAlertMessage(response.data.message);
					setAlertSeverity('success');
				}
			} catch (error) {
				setAlertMessage('Failed to delete quotation');
				setAlertSeverity('error');
				console.error('Error deleting quotation:', error);
			} finally {
				setDeleting(false);
			}
		}
	};

	useEffect(() => {
		loadQuotations();
	}, [loadQuotations]);

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
		setAnchorEl(event.currentTarget);
		setCurrentQuotationId(id);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		setCurrentQuotationId(null);
	};

	const handleStatusChange = async (id: string, newStatus: QuotationStatus) => {
		try {
			const response = await updateQuotationStatus({ status: newStatus }, id);
			const data = response;
			if (data) {
				setQuotations(
					quotations.map((q) => (q._id === id ? { ...q, status: newStatus } : q))
				);
				setAlertMessage('Status updated successfully');
				setAlertSeverity('success');
			}
		} catch (error) {
			setAlertMessage('Failed to update status');
			setAlertSeverity('error');
			console.error('Error updating status:', error);
		}
	};

	const handleDownloadQuotation = async (id: string, type: 'master' | 'client') => {
		const quotation = quotations.find((q) => q._id === id);
		if (!quotation) return;

		try {
			setLoading(true);
			const response = await HandlePDFCreate(type, id);
			const apiurl = response.data.pdfUrl;
			const pdfUrl =
				type === 'master'
					? quotation?.masterquotationPdf || apiurl
					: quotation.quotationPdf || apiurl;

			setSelectedPdfUrl(pdfUrl);
			// setPdfDialogOpen(true);
			loadQuotations();
			setAlertMessage(
				`${type === 'master' ? 'Master' : 'Client'} PDF generated successfully`
			);
			setAlertSeverity('success');
		} catch (error) {
			setAlertMessage('Failed to generate PDF');
			setAlertSeverity('error');
			console.error('Error generating PDF:', error);
		} finally {
			setLoading(false);
			handleMenuClose();
		}
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleColumnsMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setColumnsMenuAnchor(event.currentTarget);
	};

	const handleColumnsMenuClose = () => {
		setColumnsMenuAnchor(null);
	};

	const toggleColumnVisibility = (columnId: string) => {
		setColumns((prev) => ({
			...prev,
			[columnId]: !prev[columnId],
		}));
	};

	// Filter quotations based on search term
	const filteredQuotations = quotations.filter((quotation) => {
		const searchLower = searchTerm.toLowerCase();
		return (
			quotation.name?.toLowerCase().includes(searchLower) ||
			quotation.email?.toLowerCase().includes(searchLower) ||
			quotation.mobile?.toLowerCase().includes(searchLower) ||
			quotation.location?.toLowerCase().includes(searchLower)
		);
	});

	const visibleColumns = columnOptions.filter((col) => columns[col.id]);

	const handleSend = async (id: string) => {
		// const data = 'ddddddddd';
		try {
			setSendloaderQuotation(true);
			const response = await SendQuotation(id);
			// console.log(response);
			if (response.success) {
				setAlertMessage(response.data.message);
				setAlertSeverity('success');
			} else {
				setAlertMessage(response.data.errors);
				setAlertSeverity('error');
			}
		} catch (error) {
			console.log(error);
		} finally {
			setSendloaderQuotation(false);
		}
	};

	return (
		<Container maxWidth="xl" sx={{ py: 4, px: isMobile ? 1 : 2 }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					justifyContent: 'space-between',
					alignItems: isMobile ? 'flex-start' : 'center',
					mb: 4,
					gap: isMobile ? 2 : 0,
				}}
			>
				<Typography
					variant={isMobile ? 'h5' : 'h4'}
					component="h1"
					sx={{ fontWeight: 'bold' }}
				>
					{' '}
					<TextField
						variant="outlined"
						size="small"
						placeholder="Search by name, email, phone or location"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Search />
								</InputAdornment>
							),
						}}
						sx={{
							width: isMobile ? '100%' : 300,
							mr: 1,
						}}
					/>
				</Typography>
				<Box sx={{ display: 'flex', gap: 1, width: isMobile ? '100%' : 'auto' }}>
					<Tooltip title="Select columns">
						<IconButton
							onClick={handleColumnsMenuOpen}
							size={isMobile ? 'small' : 'medium'}
						>
							<ViewColumnIcon fontSize={isMobile ? 'small' : 'medium'} />
						</IconButton>
					</Tooltip>
					<Button
						variant="contained"
						startIcon={<AddCircleIcon fontSize={isMobile ? 'small' : 'medium'} />}
						onClick={() => navigate('/quotation/create')}
						size={isMobile ? 'small' : 'medium'}
					>
						{isMobile ? 'Add' : 'Add Quotation'}
					</Button>
				</Box>
			</Box>

			{loading ? (
				<Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
					<CircularProgress />
				</Box>
			) : filteredQuotations.length > 0 ? (
				<Paper elevation={2} sx={{ p: isMobile ? 1 : 2, overflowX: 'auto' }}>
					<Box sx={{ minWidth: isMobile ? '600px' : '100%' }}>
						<Table size={isMobile ? 'small' : 'medium'}>
							<TableHead>
								<TableRow>
									{visibleColumns.map((column) => (
										<TableCell key={column.id} sx={{ fontWeight: 'bold' }}>
											{column.label}
										</TableCell>
									))}
									<TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{filteredQuotations
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((quotation) => (
										<TableRow key={quotation._id} hover>
											{visibleColumns.map((column) => {
												switch (column.id) {
													case 'status':
														return (
															<TableCell key={column.id}>
																<Select
																	size="small"
																	value={quotation.status}
																	onChange={(e) =>
																		handleStatusChange(
																			quotation._id,
																			e.target
																				.value as QuotationStatus
																		)
																	}
																	sx={{
																		border: 'none',
																		'& .MuiOutlinedInput-notchedOutline':
																			{
																				border: 'none',
																			},
																		'&:hover .MuiOutlinedInput-notchedOutline':
																			{
																				border: 'none',
																			},
																		'&.Mui-focused .MuiOutlinedInput-notchedOutline':
																			{
																				border: 'none',
																			},
																	}}
																>
																	{statusOptions.map((status) => (
																		<MenuItem
																			key={status}
																			value={status}
																			sx={{
																				textTransform:
																					'capitalize',
																			}}
																		>
																			<Chip
																				label={status}
																				color={
																					status ===
																					'Quotation Sent'
																						? 'secondary'
																						: status ===
																							  'Rejected'
																							? 'error'
																							: status ===
																								  'Confirmed'
																								? 'success'
																								: status ===
																									  'Pending'
																									? 'info'
																									: status ===
																										  'Quotation Created'
																										? 'warning'
																										: status ===
																											  'Quotation Updated'
																											? 'warning'
																											: 'info'
																				}
																				size="small"
																			/>
																		</MenuItem>
																	))}
																</Select>
															</TableCell>
														);
													case 'finalAmount':
														return (
															<TableCell key={column.id}>
																₹{quotation.finalAmount.toFixed(2)}
																{/* {(
																	quotation?.finalAmount -
																	quotation?.advanceAmounts?.reduce(
																		(
																			total: number,
																			item: { amount: number }
																		) => total + item?.amount,
																		0
																	)
																)?.toFixed(2)} */}
															</TableCell>
														);
													case 'eventDate':
														return (
															<TableCell key={column.id}>
																{new Date(
																	quotation.functionDate
																).toLocaleDateString('en-US', {
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																})}
															</TableCell>
														);
													case 'updatedAt':
														return (
															<TableCell key={column.id}>
																{new Date(
																	quotation.updatedAt
																).toLocaleString()}
															</TableCell>
														);
													case 'eventType.eventType': // Added eventType
														return (
															<TableCell key={column.id}>
																{quotation.eventType?.eventType ||
																	'N/A'}
															</TableCell>
														);
													default:
														return (
															<TableCell key={column.id}>
																{String(
																	quotation[
																		column.id as keyof Quotation
																	]
																)}
															</TableCell>
														);
												}
											})}
											<TableCell>
												<IconButton
													size={isMobile ? 'small' : 'medium'}
													onClick={(e) =>
														handleMenuOpen(e, quotation._id)
													}
												>
													<MoreVert
														fontSize={isMobile ? 'small' : 'medium'}
													/>
												</IconButton>

												<Menu
													anchorEl={anchorEl}
													open={
														Boolean(anchorEl) &&
														currentQuotationId === quotation._id
													}
													onClose={handleMenuClose}
													anchorOrigin={{
														vertical: 'bottom',
														horizontal: 'right',
													}}
													transformOrigin={{
														vertical: 'top',
														horizontal: 'right',
													}}
												>
													<MenuItem
														onClick={() =>
															(window.location.href = `/quotation/${quotation._id}`)
														}
													>
														<ListItemIcon>
															<Visibility fontSize="small" />
														</ListItemIcon>
														<ListItemText>View Details</ListItemText>
													</MenuItem>
													<MenuItem
														onClick={() =>
															navigate(
																`/quotation/edit/${quotation._id}`
															)
														}
													>
														<ListItemIcon>
															<Edit fontSize="small" />
														</ListItemIcon>
														<ListItemText>Edit</ListItemText>
													</MenuItem>

													<MenuItem
														onClick={
															quotation.ifMasterquotationPdfGenrated
																? () =>
																		window.open(
																			quotation.masterquotationPdf,
																			"_blank'"
																		)
																: () =>
																		handleDownloadQuotation(
																			quotation._id,
																			'master'
																		)
														}
													>
														{quotation.ifMasterquotationPdfGenrated ? (
															<>
																<ListItemIcon>
																	<Visibility fontSize="small" />
																</ListItemIcon>
																<ListItemText>
																	View Master PDF
																</ListItemText>
															</>
														) : (
															<>
																<ListItemIcon>
																	<AutoModeIcon fontSize="small" />
																</ListItemIcon>
																<ListItemText>
																	Generate PDF Master
																</ListItemText>
															</>
														)}
													</MenuItem>
													<MenuItem
														onClick={() =>
															window.open(
																quotation.quotationPdf,
																"_blank'"
															)
														}
													>
														<ListItemIcon>
															<Visibility fontSize="small" />
														</ListItemIcon>
														<ListItemText>View Client PDF</ListItemText>
													</MenuItem>
													<MenuItem
														onClick={() => handleSend(quotation._id)}
													>
														<ListItemIcon>
															{sendloaderquotation ? (
																<CircularProgress size="30px" />
															) : (
																<SendOutlinedIcon fontSize="small" />
															)}
														</ListItemIcon>
														<ListItemText>Send Quotation</ListItemText>
													</MenuItem>
												</Menu>
												<Tooltip title="Delete">
													<IconButton
														onClick={() =>
															handleDeleteClick(quotation._id)
														}
														// size={isMobile ? 'small' : 'medium'}
													>
														<GridDeleteForeverIcon />
													</IconButton>
												</Tooltip>
											</TableCell>
										</TableRow>
									))}
							</TableBody>
						</Table>
					</Box>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={filteredQuotations.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
						labelRowsPerPage={isMobile ? 'Rows:' : 'Rows per page:'}
						sx={{
							'& .MuiTablePagination-toolbar': {
								flexWrap: isMobile ? 'wrap' : 'nowrap',
							},
						}}
					/>
				</Paper>
			) : searchTerm ? (
				<Box
					sx={{
						textAlign: 'center',
						py: 8,
						backgroundColor: 'grey.50',
						borderRadius: 1,
						border: '1px dashed',
						borderColor: 'divider',
					}}
				>
					<Typography variant="h5" component="h3" fontWeight="medium" mb={1}>
						No matching quotations found
					</Typography>
					<Typography color="text.secondary" mb={3}>
						Try adjusting your search criteria
					</Typography>
					<Button
						variant="outlined"
						onClick={() => setSearchTerm('')}
						size={isMobile ? 'small' : 'medium'}
					>
						Clear search
					</Button>
				</Box>
			) : (
				<Box
					sx={{
						textAlign: 'center',
						py: 8,
						backgroundColor: 'grey.50',
						borderRadius: 1,
						border: '1px dashed',
						borderColor: 'divider',
					}}
				>
					<Typography variant="h5" component="h3" fontWeight="medium" mb={1}>
						No quotations yet
					</Typography>
					<Typography color="text.secondary" mb={3}>
						Create your first quotation to get started
					</Typography>
					<Button
						variant="contained"
						startIcon={<AddCircleIcon />}
						onClick={() => navigate('/quotation/create')}
						size={isMobile ? 'small' : 'medium'}
					>
						Create New Quotation
					</Button>
				</Box>
			)}

			<Menu
				anchorEl={columnsMenuAnchor}
				open={Boolean(columnsMenuAnchor)}
				onClose={handleColumnsMenuClose}
				PaperProps={{
					style: {
						maxHeight: 300,
						width: 200,
					},
				}}
			>
				<Typography variant="subtitle2" sx={{ px: 2, pt: 1, fontWeight: 'bold' }}>
					Visible Columns
				</Typography>
				{columnOptions.map((column) => (
					<MenuItem
						key={column.id}
						onClick={() => toggleColumnVisibility(column.id)}
						dense
					>
						<Checkbox checked={columns[column.id]} size="small" />
						<ListItemText primary={column.label} />
					</MenuItem>
				))}
			</Menu>

			<Dialog
				open={pdfDialogOpen}
				onClose={() => setPdfDialogOpen(false)}
				fullScreen={isMobile}
				maxWidth="lg"
				fullWidth
			>
				<DialogTitle>
					<Box display="flex" justifyContent="space-between" alignItems="center">
						PDF Preview
						<IconButton onClick={() => setPdfDialogOpen(false)}>
							<Close />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent sx={{ height: '80vh', p: 0 }}>
					{selectedPdfUrl && (
						<iframe
							src={selectedPdfUrl}
							width="100%"
							height="100%"
							style={{ border: 'none' }}
							title="PDF Preview"
						/>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							window.open(selectedPdfUrl, '_blank');
							setPdfDialogOpen(false);
						}}
						variant="contained"
						color="primary"
					>
						Open in New Tab
					</Button>
					<Button onClick={() => setPdfDialogOpen(false)} variant="outlined">
						Close
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={deleteDialogOpen}
				onClose={handleCloseDeleteDialog}
				maxWidth="xs"
				fullWidth
				PaperProps={{
					style: {
						borderRadius: isMobile ? 0 : '12px',
					},
				}}
				fullScreen={isMobile}
			>
				<DialogTitle sx={{ fontFamily: 'Poppins', fontWeight: 600 }}>
					Confirm Delete
				</DialogTitle>
				<DialogContent>
					<Typography variant="body1" sx={{ fontFamily: 'Poppins', mt: 2 }}>
						Are you sure you want to delete this menu? This action cannot be undone.
					</Typography>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 3 }}>
					<Button
						onClick={handleCloseDeleteDialog}
						color="primary"
						variant="outlined"
						disabled={deleting}
					>
						Cancel
					</Button>
					<Button
						onClick={handleDeleteQuotation}
						color="error"
						variant="contained"
						disabled={deleting}
						startIcon={
							deleting ? (
								<CircularProgress size={20} color="inherit" />
							) : (
								<GridDeleteIcon />
							)
						}
						sx={{ minWidth: '100px' }}
					>
						{deleting ? 'Deleting...' : 'Delete'}
					</Button>
				</DialogActions>
			</Dialog>

			<Toast
				alertSeverity={alertSeverity}
				alertMessage={alertMessage}
				setAlertMessage={setAlertMessage}
			/>
		</Container>
	);
};

export default QuotationPage;
